import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

const refetchSubscribers = new Set();

export const useRefetchTrigger = () => {
  const [refetchKey, setRefetchKey] = useState(0);
  const activeCampus = useSelector((state) => state.meta.activeCampus);

  useEffect(() => {
    refetchSubscribers.add(setRefetchKey);
    return () => {
      refetchSubscribers.delete(setRefetchKey);
    };
  }, []);

  // Trigger refetch when campus changes
  useEffect(() => {
    if (activeCampus) {
      setRefetchKey(prev => prev + 1);
    }
  }, [activeCampus]);

  return {
    refetchKey,
    triggerRefetch: () => {
      refetchSubscribers.forEach(subscriber => subscriber(prev => prev + 1));
    }
  };
};